import axios from 'axios';
import { LoginResponse } from '../modal/LoginResponse';
import { SignupResponse } from '../modal/SignupResponse';
import { VerifyResponse } from '../modal/VerifyResponse';

export const login = async (
  username: string,
  password: string,
): Promise<LoginResponse> => {
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  let url = `${apiBaseUrl}/api/login`;
  return new Promise<LoginResponse>(async (resolve, reject) => {
    const params = new URLSearchParams({ email: username, password: password });
    axios.post<LoginResponse>(url,params,{headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const signup = async (
  email: string,
  password: string,
  repassword: string,
  username: string,
  lang: string
): Promise<SignupResponse> => {
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  let url = `${apiBaseUrl}/api/signup`;
  return new Promise<SignupResponse>(async (resolve, reject) => {
    const params = new URLSearchParams({
        email: email, 
        password: password,
        repassword: repassword,
        username: username,
        lang: lang
      });
    axios
      .post<SignupResponse>(url,params,{headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const verify = async (
  token: string,
): Promise<VerifyResponse> => {
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  let url = `${apiBaseUrl}/api/verify`;
  return new Promise<VerifyResponse>(async (resolve, reject) => {
     const params = new URLSearchParams({});
    axios
      .post<VerifyResponse>(url,params,{headers: {'Content-Type': 'application/x-www-form-urlencoded','Authorization':token}})
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const resetpassword = async (
  email: string,
  lang: string
): Promise<void> => {
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  let url = `${apiBaseUrl}/api/resetpassword`;
  return new Promise<void>(async (resolve, reject) => {
    const params = new URLSearchParams({email: email, lang: lang});
    axios
      .post<void>(url,params,{headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const changepassword = async (
  password: string,
  repassword: string,
  token: string,
  lang: string
): Promise<void> => {
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  let url = `${apiBaseUrl}/api/changepassword`;
  return new Promise<void>(async (resolve, reject) => {
    const params = new URLSearchParams({password: password,repassword: repassword,lang: lang});
    axios
      .post<void>(url,params,{headers: {'Content-Type': 'application/x-www-form-urlencoded','Authorization':token}})
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};


export const genlink = async (
  name: string,
  userid: string,
  token: string,
): Promise<LoginResponse> => {
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  let url = `${apiBaseUrl}/api/link`;
  return new Promise<LoginResponse>(async (resolve, reject) => {
    const params = new URLSearchParams();
    params.append('name',name);
    params.append('no', userid);
    axios.post<LoginResponse>(url,params,{
      headers: 
      {'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization':token
      }})
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};